import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { dismissA2hsHint, shouldShowA2hsHint } from './a2hs.util';

@Component({
  selector: 'app-a2hs-hint',
  standalone: true,
  templateUrl: './a2hs-hint.html',
  styleUrl: './a2hs-hint.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class A2hsHint {
  protected readonly visible = signal(shouldShowA2hsHint(window));

  protected dismiss(): void {
    dismissA2hsHint(window);
    this.visible.set(false);
  }
}
